import { render, staticRenderFns } from "./participateActivities.vue?vue&type=template&id=0410a89e&scoped=true"
import script from "./participateActivities.vue?vue&type=script&lang=js"
export * from "./participateActivities.vue?vue&type=script&lang=js"
import style0 from "./participateActivities.vue?vue&type=style&index=0&id=0410a89e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0410a89e",
  null
  
)

export default component.exports